import dynamic from 'next/dynamic';
import {
  Wrapper,
  SearchWrapper,
  DeleteFilterWrapper,
  SelectsWrapper,
  DesktopSkeletonWrapper,
  MobileSkeletonRow,
  MobileSkeletonControls,
  MobileSkeletonDeleteFilterWrapper,
} from './styles';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';

export const DynamicGameFilter = dynamic(
  () => import('./game-filter').then((m) => m.GameFilter),
  {
    ssr: false,
    loading: () => (
      <>
        <Wrapper>
          <DesktopSkeletonWrapper>
            <SearchWrapper>
              <SkeletonLoader height={42} />
            </SearchWrapper>
            <DeleteFilterWrapper />
            <SelectsWrapper>
              <SkeletonLoader width={140} height={42} />
              <SkeletonLoader width={140} height={42} />
            </SelectsWrapper>
          </DesktopSkeletonWrapper>
          <MobileSkeletonRow>
            <MobileSkeletonControls>
              <SkeletonLoader width="100%" height={42} />
              <SkeletonLoader width="100%" height={42} />
            </MobileSkeletonControls>
            <SkeletonLoader height={42} containerClassName="flex-1" />
          </MobileSkeletonRow>
        </Wrapper>
        <MobileSkeletonDeleteFilterWrapper />
      </>
    ),
  }
);
